import { useMutation } from "@apollo/client";
import { REMOVE_CURRENT_USER_FROM_SHARE } from "../../graphql/mutations/ShareContext";

// eslint-disable-next-line import/prefer-default-export
export const useRemoveCurrentUserFromShare = ({ onError, onSuccess }) => {
  const [removeCurrentUserFromShare, { loading }] = useMutation(
    REMOVE_CURRENT_USER_FROM_SHARE
  );

  const handleRemoveCurrentUserFromShare = async ({ shareId }) => {
    try {
      const res = await removeCurrentUserFromShare({ variables: { shareId } });
      if (
        res &&
        res.data &&
        res.data.shareContext &&
        res.data.shareContext.removeCurrentUserFromShare
      ) {
        handleSuccess(shareId);
      } else {
        handleError(shareId, null);
      }
    } catch (e) {
      handleError(shareId, e);
    }
  };

  function handleError(shareId, e) {
    if (typeof onError === "function") {
      onError(e, { shareId });
    } else {
      console.error("** ", e);
      console.warn("** Missing 'onError' function.");
    }
  }

  function handleSuccess(shareId) {
    if (typeof onSuccess === "function") {
      onSuccess({ shareId });
    } else {
      console.warn("** Missing 'onSuccess' function.");
    }
  }

  return { execute: handleRemoveCurrentUserFromShare, loading };
};
